export enum ProductTypeCode {
    파킹 = '1001',
    예금 = '1002',
    적금 = '1003',
    CMA = '104',
}

export enum ProductFeature {
    ONLINE = 'online',
    PROTECTION = 'protection',
    STOCK = 'stock',
    CHECK_CARD = 'checkcard',
    FEE = 'fee',
}

export enum ProductCategory {
    SPECIAL_OFFER = 'specialOffer',
    ONLINE = 'online',
    ANYONE = 'anyone',
    SAVING_FOR_YOUTH = 'savingForYouth',
    SAVING_FOR_SOLDIER = 'savingForSoldier',
    HOUSING_SUBSCRIPTION = 'housingSubscription',
    SAVING_FREE = 'savingFree',
    SAVING_FIXED = 'savingFixed',
    SAVING_FOR_JUMPING_YOUTH = 'savingForJumpingYouth',
}

export enum ProductSortType {
    기본금리순 = 'INTEREST_RATE',
    최고금리순 = 'PRIME_INTEREST_RATE',
}

export interface SavingsProduct {
    typeCode: ProductTypeCode // 상품코드
    code: string
    companyCode: string
    name: string // 상품명
    companyLogo: string // 상품 로고
    companyName?: string // 회사명
    cuName?: string // 신협(조합)명
    interestRate?: string // 기본금리
    primeInterestRate: string // 최고 금리
    cmaInterestRate?: string // cma 금리
    features?: ProductFeature[]
    productCategories?: ProductCategory[]
    isBrokerage: boolean
}

export interface SavingsProdustListResponse {
    totalCount: number
    offSet: number
    size: number
    products: SavingsProduct[]
}
